import { observer } from "mobx-react";
import { useEffect } from "react";
import { useStores } from "../../../stores";

export const BitrixScriptLoader = observer(() => {
	const { countryStore } = useStores();

	useEffect(() => {
		const scriptUrl =
			countryStore.countryCode === "ru"
				? "https://cdn-ru.bitrix24.ru/b34100556/crm/site_button/loader_1_htnl83.js"
				: "https://cdn-ru.bitrix24.ru/b34100556/crm/site_button/loader_3_hntq2f.js";

		const scriptId = "bitrix-script-loader";

		// Проверка: если скрипт уже добавлен, не дублируем
		if (document.getElementById(scriptId)) return;

		const script = document.createElement("script");
		script.id = scriptId;
		script.async = true;
		script.src = `${scriptUrl}?${Math.floor(Date.now() / 60000)}`;

		const firstScript = document.getElementsByTagName("script")[0];
		firstScript.parentNode?.insertBefore(script, firstScript);
	}, [countryStore.countryCode]);

	return null;
});
